import React from "react";

function Input(props) {
  let listClasses = "items-center xl:p-0 my-0 xl:h-full text-middle-grey border-charcoal border-b-1 xl:border-b-0 xl:border-r-1 flex flex-row xl:flex-col justify-start xl:justify-start " + (props.listClasses ? props.listClasses : "");
  let imgSpacingClasses = "flex " + (props.imgSpacingClasses ? props.imgSpacingClasses : "");
  let imgClasses = (props.imgClasses ? props.imgClasses : "");
  let labelClasses = "font-mont font-w-500 tracking-1 uppercase flex " + (props.labelClasses ? props.labelClasses : "");
  
  return (
    <li className={listClasses}> 
      <a href={props.href} className={imgSpacingClasses}>
        <div className={imgClasses}>{props.children}</div>
      </a>
      <a href={props.href} className="flex justify-center">
        <span className={labelClasses}>{props.label}</span>
      </a>
    </li>
  );
}

export default Input;